export default __webpack_public_path__ + "static/media/Chestplate of Bloodlust.beffb095.jpg";